'use strict';

const alert = [
  '$rootScope',
  '$timeout',
  'modal',

  function ($rootScope, $timeout, modal) {
    return {
      show: function (options, modalOptions = {}) {
        var scope = $rootScope.$new();

        scope.options = options;

        if (options.autoClose) {
          $timeout(() => {
            modal.close();
          }, 2000);

          modalOptions.cssClass = 'Alert-autoClose Modal--sharpCorners';
          modalOptions.closeOnBackgroundClick = true;
          modalOptions.closeOff = true;
        }

        return modal.open(angular.extend({
          template: '<sa-alert accept="close()" decline="dismiss()" options="options"></sa-alert>',
          scope: scope
        }, modalOptions)).result;
      }
    };
  }
];

export default alert;



// WEBPACK FOOTER //
// ./app/src/services/alert.js